import React, { useRef } from "react";
import { ExternalLink, Image as ImageIcon } from "lucide-react";

import MediaPlayer from "./MediaPlayer";

interface StandardVideoThumbnailProps {
  type: "video" | "image" | "website";
  thumbnail: string;
  videoUrl?: string;
  onClick: () => void;
  height?: string;
  width?: string;
}

const StandardVideoThumbnail: React.FC<StandardVideoThumbnailProps> = ({
  type,
  thumbnail,
  videoUrl,
  onClick,
  height,
  width,
}) => {
  const videoRef = useRef<HTMLVideoElement>(
    null,
  ) as React.RefObject<HTMLVideoElement>;

  const getIcon = () => {
    switch (type) {
      case "website":
        return <ExternalLink size={32} className="text-white" />;
      case "image":
        return <ImageIcon size={32} className="text-white" />;
      default:
        return null;
    }
  };

  return (
    <div
      onClick={onClick}
      className="group relative w-full cursor-pointer overflow-hidden rounded-lg shadow-lg transition-shadow hover:shadow-xl"
      role="button"
      tabIndex={0}
      style={{ height, width }}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <div className="aspect-auto">
        {type === "video" && videoUrl ? (
          <MediaPlayer
            media={{
              type: "video",
              url: videoUrl,
            }}
            isMuted={true}
            autoPlay={false}
            videoRef={videoRef}
          />
        ) : (
          <img
            src={thumbnail}
            alt="Thumbnail"
            className="h-full w-full object-cover"
          />
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors group-hover:bg-black/50">
          <div className="flex h-16 w-16 transform items-center justify-center rounded-full bg-transparent transition-transform group-hover:scale-110"></div>
          {getIcon()}
        </div>
      </div>
    </div>
  );
};

export default StandardVideoThumbnail;
